import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_ITEMS = [
  { to: '/',           icon: 'bi-grid-fill',       label: 'Dashboard'  },
  { to: '/tasks',      icon: 'bi-check2-square',   label: 'Tasks'      },
  { to: '/shopping',   icon: 'bi-cart3',           label: 'Shopping'   },
  { to: '/thoughts',   icon: 'bi-journal-text',    label: 'Thoughts'   },
  { to: '/activities', icon: 'bi-lightning-charge',label: 'Activities' },
  { to: '/workouts',   icon: 'bi-bicycle',         label: 'Workouts'   },
  { to: '/golf',       icon: 'bi-trophy',          label: 'Golf'       },
  { to: '/golf-tips',  icon: 'bi-flag',            label: 'Golf Tips'  },
  { to: '/health',        icon: 'bi-heart-pulse',     label: 'Health'       },
  { to: '/transactions',  icon: 'bi-credit-card',     label: 'Expenses' },
];

export default function Sidebar() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login');
  }

  return (
    <nav className="sidebar">
      <a href="/" className="sidebar-brand">
        <img src="/DNA_Icon-primary.png" alt="logo" />
        <span>NeuroDNA</span>
      </a>

      <ul className="sidebar-nav">
        {NAV_ITEMS.map(({ to, icon, label }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === '/'}
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              <i className={`bi ${icon}`} />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="sidebar-footer">
        <ul className="sidebar-nav" style={{ padding: 0 }}>
          <li>
            <button onClick={handleSignOut}>
              <i className="bi bi-box-arrow-left" />
              <span>Sign out</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
